import { render, staticRenderFns } from "./notificationListInChat.vue?vue&type=template&id=41fc4edf&scoped=true"
import script from "./notificationListInChat.vue?vue&type=script&lang=js"
export * from "./notificationListInChat.vue?vue&type=script&lang=js"
import style0 from "./notificationListInChat.vue?vue&type=style&index=0&id=41fc4edf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc4edf",
  null
  
)

export default component.exports